import React, { Component } from "react";
import Cookies from "js-cookie";
import TagManager from "react-gtm-module";
import axios from "axios";
import Header from "../components/Header/Header";
import Loader from "../components/Loader/Loader";
import ApiError from "../components/ApiError/ApiError";
import CheckoutPageError from "../components/CheckoutPageError/CheckoutPageError";
import ConfirmationItem from "../components/ConfirmationItem/ConfirmationItem";
import styled from "styled-components";
import thumbIcon from "../assets/images/icons/ic_thumbs_up.svg";
import checkIcon from "../assets/images/icons/ic_check_black.svg";
import caretDownIcon from "../assets/images/icons/ic_caret_down.svg";
import warningIcon from "./../assets/images/icons/ic_warning.svg";
import * as Variable from "../CSSVariables";
import * as GlobalStyle from "../CSSStyles";

const gtmId = "GTM-MXMG453";

const HeaderWrapperStyle = styled.div`
  a {
    display: none;
  }
`;
const ThankyouBodyStyle = styled.section`
  a.home-btn {
    display: inline-block;
    max-width: 381px;
    width: 100%;
    margin: 16px 0 32px;

    @media only screen and (min-width: ${Variable.desktop}) {
      width: 40%;
    }
  }
  .api-error {
    width: 82%;
    margin: 0 auto;
  }
  a {
    color: ${Variable.scienceBlue};

    &:hover {
      &:not(.link-as-btn) {
        text-decoration: underline;
      }
    }
  }
`;
const ThankyouAccordionStyle = styled.div`
  border-radius: 8px;
  overflow: hidden;
  padding: 20px 0;

  .tab {
    width: 100%;
    color: white;
    overflow: hidden;
    input {
      display: none;
      visibility: hidden;
      position: absolute;
      left: -9999px;
      z-index: -999;

      ~ button{
        border: 0;
        background: none;

        &:hover{
          span{
            color: ${Variable.congressBlue};
          }
        }
      }

      &:checked {
        ~ button{
          .tab-label {
              span {
                visibility: hidden;
                font-size: 0;
                &::after {
                  content: "Hide order details";
                  visibility: visible;
                  font-size: 1.8rem;
                }
              }
              img {
                transform: rotate(180deg);
              }
            }
          }
        ~ .mobile-close{
          display: block;
          
          @media only screen and (min-width: ${Variable.tablet}){
            display: none;
          }
        }
        ~ .tab-content {
          max-height: 1000vh;
        }
      }
    }
    .tab-label {
      font-size: 1.8rem;
      cursor: pointer;
      color: ${Variable.lochmara};
      font-weight: ${Variable.semiBold};
      position: relative;
      display: inline-block;
      
      button{
        border:0;
        background: none;
      }
      span{
        color: ${Variable.lochmara};
      }
      &.mobile-close{
        margin-top: 20px;
        display: none;

        img {
          transform: rotate(180deg);
        }
      }

      &:hover {
        text-decoration: underline;
      }

      img {
        margin-left: 12px;
        transition: all 0.2s;
      }
    }
    .tab-content {
      max-height: 0;
      color: #000;
      background: white;
      transition: all 0.35s;

      .container-fluid {
        padding: 0;

        &.items-header {
          text-align: left;

          .items-header-label{
            display: none;

            @media only screen and (min-width: ${Variable.tablet}) {
              display: flex;
            }
          }
          .availability {
            font-size: 2.0rem;
            font-weight: ${Variable.semiBold};
            margin: 22px 0;
          }
          .price {
            text-align: right;
          }
        }
        .total{
          text-align: right;
        }
      }
      .preorder-total-wrapper {
        padding: 30px 0;

        .row {
          > div {
            padding: 4px 15px;
          }
        }
        .label {
          text-align: left;
        }
        .value {
          text-align: right;
        }
        
        .total {

          * {
            font-size: 1.8rem;
            font-weight: ${Variable.semiBold};
          }
          .vat {
            font-size: 1.4rem;
            font-weight: ${Variable.regular};
            color: ${Variable.cloud};
          }
        }
      }
      .address-wrapper {
        text-align: left;

          .icon-wrapper{
            padding-bottom: 12px;
            border-bottom:1px solid ${Variable.alto};

            ~{
              &.row{
                margin-bottom: 20px;

                @media only screen and (min-width: ${Variable.mobile}){
                  margin-bottom: 0;
                }
              }
            }

            img{
              height: 20px;
            }
          }
          .title{
            font-size: 1.8rem;
            font-weight: ${Variable.semiBold};
          }
        }
      }
    }
  }
  .grand-total{
    border-top:1px solid ${Variable.alto};
    margin-top: 12px;
    padding-top: 12px;
  }
  .promo{
    border-top:1px solid ${Variable.alto};
    margin-top: 12px;
    padding-top: 12px;

    .value{
      color: ${Variable.japaneseLaurel}
    }
  }
`;
const SmallStyle = styled.p`
  font-size: 1.8rem;
  font-weight: ${Variable.regular};
  line-height: 24px;
  br {
    display: none;

    @media only screen and (min-width: ${Variable.mobile}) {
      display: inline-block;
    }
  }
`;
const MediumStyle = styled.p`
  font-size: 3rem;
  font-weight: ${Variable.semiBold};
`;
const LargeStyle = styled.p`
  font-size: 2.6rem;
  font-weight: ${Variable.semiBold};
  line-height: 36px;
`;
const Thumb = styled.img`
  height: 28px;
  width: 28px;
`;
const SectionStyle = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 60px 0;

  @media only screen and (min-width: ${Variable.desktop}) {
    max-width: 800px;
  }
`;
const OrderNumberStyle = styled.span`
  color: ${Variable.valhalla};
  background-color: ${Variable.mystic};
  padding: 8px 12px;
  font-weight: ${Variable.medium};
  font-size: 2.6rem;
`;
const OrderDetails = styled.div`
  border: 1px solid ${Variable.alto};
  border-left: 0;
  border-right: 0;
`;
// const LinkStyle = styled.a`
//   color: ${Variable.lochmara};
//   &:active,
//   &:link,
//   &:visited {
//     // text-decoration: underline;
//   }
// `;
const CreateAccountStyle = styled.div`
  height: 100%;
  background-color: ${Variable.mystic};
  z-index: -5;

  top: 0;

  @media only screen and (min-width: ${Variable.desktop}) {
    position: fixed;
    z-index: 0;
  }
  @media only screen and (min-width: ${Variable.largeDesktop}) {
    width: 437px;
  }

  .create-content {
    transform: none;
    margin: 0 auto;
    top: 33%;
    text-align: center;
    padding: 44px 20px;

    @media only screen and (min-width: ${Variable.desktop}) {
      min-width: 290px;
      padding: 30px;
      position: relative;
    }
    p {
      text-align: center;
      font-size: 2.6rem;
      line-height: 3.2rem;
      font-weight: ${Variable.semiBold};
      margin: 0;
    }
    ul {
      list-style-type: none;
      text-align: left;
      margin: 0 auto;
      display: inline-block;
      margin: 20px 0;

      li {
        position: relative;
        margin: 20px 0;
        &::before {
          content: "";
          background-image: url(${checkIcon});
          background-size: cover;
          background-repeat: no-repeat;
          background-position: bottom;
          padding: 6px;
          position: absolute;
          left: -24px;
        }
      }
    }
  }
`;

export const AddressSummaryStyle = styled.div`
  text-align: left;
  border-top: 1px solid ${Variable.alto};
  border-bottom: 1px solid ${Variable.alto};
  margin: 40px 0;
  padding: 10px 0;

  .customer-name {
    font-weight: ${Variable.medium};
    margin-bottom: 0.5rem;
    display: block;
  }
`;

const BoldStyle = styled.span`
  font-weight: ${Variable.semiBold};
`;

const UnableProcessStyle = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  display: block;
  text-align: center;
  width: 100%;
  z-index: 1;

  img {
    height: 3rem;
  }

  p {
    font-size: 1.6rem;
    margin: 2.8rem 0;
  }
  .link-as-btn {
    max-width: 30rem;
  }
`;

class ThankYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // processPurchaseAPIURL: "../test_data/process-purchase.json",
      processPurchaseAPIURL: "/api/checkout/process-purchase",
      processPurchase: [],
      processPurchaseOrderAvailable: [],
      processPurchaseOrderPreOrder: [],
      processPurchaseOrderPartial: [],
      processPurchaseOrderSummary: [],
      processPurchaseLoaded: false,
      unableToProcess: false,
      unableToProcessCode: "",
      unableToProcessReference: "",
      unableToProcessMessage: "",
      preOrderTotal: "",
      chargeNow: "",
      orderDiscountTotals: "",
      subTotal: "",
      taxFee: "",
      shippingFee: "",
      total: "",
      promoCode: "",
      promoCodeValue: "",
      promoExtLabel: "",
      deliveryMethodLabel: "",
      taxLabel: "",
      currency: "",
      currencyCodeSymbol: "",
      deliveryLabel: "",
      totalLabel: "",
      isGuest: false,
      loader: false,
      isEmailAU: false,
      isUnableEmailAU: false,
      contactEmail: "",
      tyAPIErrorCode: "",
      tyAPIErrorMessage: "",
      displayError: false,
      purchaseItems: [],
      affiliation: "",
    };
  }
  componentDidMount() {
    // if (this.props.data.isAdmin) {
    //   window.location.href = "./";
    if (this.props.isGuestCheckoutBlank()) {
      window.location.href = "./#" + this.props.data.bagPagePath;
    } else {
      this.getProcessPurchaseAPI();
    }

    this.toggleOrderDetailsRef = React.createRef();
  }

  getProcessPurchaseAPI = () => {
    this.setState({ loader: true }, () => {
      axios
        .get(
          this.state.processPurchaseAPIURL,
          {
            params: {
              kk_customer_id: Cookies.get("KK_CUSTOMER_ID"),
              kk_session_id: Cookies.get("KK_SESSION_ID"),
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.orderId) {
            // Remove minibag count from localStorage.
            localStorage.removeItem("MINIBAG_COUNT");
            this.setState(
              {
                processPurchase: response.data,
                processPurchaseLoaded: true,
                processPurchaseOrderAvailable:
                  response.data.order.availableOrder,
                processPurchaseOrderPreOrder: response.data.order.preOrder,
                processPurchaseOrderPartial: response.data.order.partial,
                processPurchaseOrderSummary: response.data.orderSummary,
                isGuest: response.data.isGuest == 1,
                contactEmail:
                  response.data.contactEmail || "directcustserve@cambridge.org",
                isEmailAU:
                  response.data.contactEmail == "enquiries@cambridge.edu.au",
                affiliation: response.data.gtm.affiliation,
              },
              () => {
                this.setState(
                  {
                    loader: false,
                    preOrderTotal: this.state.processPurchaseOrderSummary
                      .preOrderTotal,
                    orderDiscountTotals: this.state.processPurchaseOrderSummary
                      .orderDiscountTotals,
                    subTotal: this.state.processPurchaseOrderSummary.subTotal,
                    chargeNow: this.state.processPurchaseOrderSummary.chargeNow,
                    taxFee: this.state.processPurchaseOrderSummary.taxFee,
                    shippingFee: this.state.processPurchaseOrderSummary
                      .shippingFee,
                    total: this.state.processPurchaseOrderSummary.total,
                    promoCode: this.state.processPurchaseOrderSummary.promoCode,
                    promoCodeValue: this.state.processPurchaseOrderSummary
                      .promoCodeValue,
                    promoExtLabel: this.state.processPurchaseOrderSummary
                      .promoExtLabel,
                    deliveryMethodLabel: this.state.processPurchaseOrderSummary
                      .deliveryMethodLabel,
                    taxLabel: this.state.processPurchaseOrderSummary.taxLabel.toLowerCase() == "gst included" ? "GST" : this.state.processPurchaseOrderSummary.taxLabel,
                    currencyCodeSymbol: this.state.processPurchaseOrderSummary
                      .currencyCodeSymbol,
                    currency: this.state.processPurchaseOrderSummary
                      .currencyCode,
                    deliveryLabel: this.state.processPurchaseOrderSummary
                      .deliveryLabel,
                    totalLabel: this.state.processPurchaseOrderSummary
                      .totalLabel,
                  },
                  () => {
                    this.triggerGTM("purchase");
                  }
                );
              }
            );
          } else if (response.data) {
            if (
              (response.data.reference &&
                parseInt(response.data.reference) == 0) ||
              response.data.reference == undefined ||
              response.data.reference == null
            ) {
              // window.location.href = "./";
              window.location.href = "./#" + this.props.data.bagPagePath;
            } else {
              this.setState(
                {
                  loader: false,
                  unableToProcess: true,
                  unableToProcessCode: response.data.code,
                  unableToProcessReference: response.data.reference,
                  unableToProcessMessage: response.data.message,
                  unableToProcessEmail:
                    response.data.contactEmail ||
                    "directcustserve@cambridge.org",
                  isUnableEmailAU:
                    response.data.contactEmail == "enquiries@cambridge.edu.au",
                  displayError: false,
                },
                () => {
                  this.triggerGTM("failedPurchase");
                }
              );
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorMessage = "Order details not loaded.";

            this.setState({
              loader: false,
              tyAPIErrorCode: errorCode,
              tyAPIErrorMessage: errorMessage,
              displayError: true,
            });
          }
        });
    });
  };
  triggerGTM = (action) => {
    if (
      window["google_tag_manager"] &&
      window["google_tag_manager"][gtmId] &&
      window["google_tag_manager"][gtmId].dataLayer
    ) {
      window["google_tag_manager"][gtmId].dataLayer.reset();
    }

    switch (action) {
      case "purchase":
        // ------------------- on load Thank You page API ------------------- //

        const items = [
          ...this.state.processPurchaseOrderAvailable,
          ...this.state.processPurchaseOrderPreOrder,
          ...this.state.processPurchaseOrderPartial,
        ];
        const gtmOrderId = this.state.processPurchase.orderId;
        const gtmAaffiliation = this.state.affiliation;
        const gtmRrevenue = this.state.subTotal;
        const gtmTax = this.state.taxFee;
        const gtmShipping = this.state.shippingFee;
        const gtmCoupon = this.state.promoCodeValue;
        const gtmCurrency = this.state.currency;
        const purchaseItems = items.map((item) => {
          return {
            name: item.title,
            id: item.isbn,
            price:
              item.discountedPrice && item.discountedPrice > 0
                ? item.discountedPrice
                : item.price,
            brand: item.gtm.brand,
            category: item.gtm.category,
            variant: item.gtm.variant,
            quantity: item.quantity,
          };
        });
        this.setState(
          {
            purchaseItems: purchaseItems,
          },
          () => {
            // GA3 & GA4 on load "purchase" event
            var stream;
            const purchaseItemsGA4 = items.map((item, index) => {
              if (index == 0) {
                stream = item.gtm.brand;
              }
              return {
                item_id: item.isbn, // The ID of the item, in our case ISBN
                item_name: item.title, // The name of the item
                affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location.
                coupon: gtmCoupon, // The coupon name/code associated with the item.
                currency: gtmCurrency, // Currency of the items associated with the event
                discount: item.discountedPrice ? (parseFloat(item.price - item.discountedPrice)) : 0.00, // The monetary discount value associated with the item.
                index: index, // The index/position of the item in a list.
                item_brand: item.gtm.brand, // The brand of the item. In our case academic, education or cambridge english
                item_category: (typeof item.subject !== "undefined") ? item.subject : "", // Subject
                item_category2: (typeof item.learningStage !== "undefined") ? item.learningStage : "", // Learning Stage
                item_category3: (typeof item.qualification !== "undefined") ? item.qualification : "", // Qualification
                item_category4: (typeof item.type !== "undefined") ? item.type : "", // Format
                item_category5: (typeof item.series !== "undefined") ? item.series : "", // Series Name
                item_list_id: "", // The ID of the list in which the item was presented to the user. We may not be using this.
                item_list_name: Cookies.get("ITEM_LIST"), // The name of the list in which the item was presented to the user. In this case Bag List
                item_variant: item.gtm.variant, // The item variant or unique code or description for additional item details/options.
                location_id: "", // The physical location associated with the item (e.g. the physical store location) NA
                price: parseFloat(item.price), // The monetary price of the item, in units of the specified currency parameter.
                quantity: item.quantity, // Item quantity.
              }

            });

            const tagManagerArgs_purchase_GA4 = {
              gtmId: gtmId,
              dataLayer: {
                event: "purchase", // name of an event. In this case, always stays as purchase
                ecommerce: { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                  purchase: {
                    // name of an action. In this case, always stays as purchase
                    actionField: {
                      id: gtmOrderId, // order id. required
                      affiliation: gtmAaffiliation, // name of the affiliate. or affiliate id
                      revenue: parseFloat(gtmRrevenue), // order revenue without taxes
                      tax: parseFloat(gtmTax), // taxes (excluding shipping)
                      shipping: parseFloat(gtmShipping), // shipping cost
                      coupon: gtmCoupon, // coupon code used in this transaction
                    },
                    products: this.state.purchaseItems,
                  },
                  transaction_id: gtmOrderId, // order id. required
                  affiliation: "Cambridge", // name of the affiliate. or affiliate id
                  value: parseFloat(gtmRrevenue), // order revenue without taxes
                  tax: parseFloat(gtmTax), // taxes (excluding shipping)
                  shipping: parseFloat(gtmShipping), // shipping cost
                  currency: gtmCurrency, // currency of the items associated with the event
                  coupon: gtmCoupon, // the coupon name/code associated with the item.
                  items: purchaseItemsGA4, // the items for the event - this is an array
                },
                stream: stream
              }
            }

            if (typeof Cookies.get("GIGYA_UID") !== "undefined") {
              const tagManagerArgs_userId = {
                gtmId: gtmId,
                dataLayer: {
                  userId: Cookies.get("GIGYA_UID")
                },
              };
    
              TagManager.dataLayer(tagManagerArgs_userId);
            }

            // GA4 Data Layer Push
            TagManager.dataLayer(tagManagerArgs_purchase_GA4);
          }
        );
        break;
      case "failedPurchase":
        // ------------------- when purchase is failed ------------------- //

        const failedPurchaseMessage = this.state.unableToProcessMessage;
        const failedOrderId = this.state.unableToProcessReference;

        const tagManagerArgs_failedPurchase = {
          gtmId: gtmId,
          dataLayer: {
            event: "failedPurchase", // name of an event. In this case, always stays as failedPurchase
            order_id: failedOrderId,
            status: failedPurchaseMessage !== undefined || failedPurchaseMessage !== null ? failedPurchaseMessage : "Failed to log error message",
          },
        };

        TagManager.dataLayer(tagManagerArgs_failedPurchase);

        break;
    }
  };
  toggleOrderDetails = (event) => {
    if (event.key === "Enter") {
      this.toggleOrderDetailsRef.current.click();
    }
  };
  createAccountClick = () => {
    this.setCookies("/"); //redirect to homepage after creating an account on SAP-CDC page
  };
  setCookies = (e) => {
    Cookies.set("customRedirect", e);
  };
  render() {
    return (
      <div>
        <HeaderWrapperStyle>
          <Header headerTitle={this.state.unableToProcess?'Sorry, we were unable to process your order':this.props.headerTitle} />
        </HeaderWrapperStyle>
        <ThankyouBodyStyle className="checkout-body">
          <div
            className="section-main"
            style={{ minHeight: "calc(100vh - 175px)" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {this.state.loader ? <Loader /> : ""}
                </div>
              </div>
              {this.state.processPurchaseLoaded ? (
                <div className="row">
                  <div
                    className={
                      this.state.isGuest ? "col-12 col-lg-8 " : "col-12"
                    }
                  >
                    <SectionStyle>
                      <Thumb src={thumbIcon} alt=""></Thumb>
                      <LargeStyle>
                        Thank you! <br />
                        Your order is complete.
                      </LargeStyle>
                      <SmallStyle>
                        Your order number is:{" "}
                        <OrderNumberStyle>
                          {this.state.processPurchase.orderId}
                        </OrderNumberStyle>
                      </SmallStyle>
                      <AddressSummaryStyle>
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <h3>Delivery Address</h3>
                            <p>
                              <span className="customer-name">
                                {this.state.processPurchase.customerName}
                              </span>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: this.state.processPurchase
                                    .deliveryAddress,
                                }}
                              ></span>
                            </p>
                          </div>
                          <div className="col-12 col-md-4">
                            <h3>Billing Address</h3>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.processPurchase
                                  .billingAddress,
                              }}
                            ></p>
                          </div>
                          <div className="col-12 col-md-4">
                            <h3>{this.state.deliveryLabel}</h3>
                            <p>Aim to deliver within 7 days</p>
                          </div>
                        </div>
                      </AddressSummaryStyle>
                      <SmallStyle>
                        An order confirmation email will be sent to your inbox
                        shortly.
                        <br /> You will be notified by email as soon as the
                        order has been sent.
                      </SmallStyle>
                      {this.state.isEmailAU ? (
                        <SmallStyle>
                          See our{" "}
                          <a href="/shopping-help" target="_blank">
                            Shopping help
                          </a>{" "}
                          for general information on ordering.
                          <br />
                          For any enquiries about your order, contact Customer
                          Services.
                          <br />
                          Telephone number{" "}
                          <a href="tel:+61(03)86711400">
                            +61 (03) 8671 1400
                          </a>{" "}
                          (9am to 5pm AEST (Apr-Sep)/AEDT (Oct-Mar)), <br />
                          email{" "}
                          <a href={"mailto:" + this.state.contactEmail}>
                            {this.state.contactEmail}{" "}
                          </a>
                        </SmallStyle>
                      ) : (
                        <SmallStyle>
                          See our{" "}
                          <a href="/shopping-help" target="_blank">
                            Shopping help
                          </a>{" "}
                          for general information on ordering.
                          <br />
                          For any enquiries about your order, contact Customer
                          Services.
                          <br /> Email{" "}
                          <a href={"mailto:" + this.state.contactEmail}>
                            {this.state.contactEmail}{" "}
                          </a>
                        </SmallStyle>
                      )}
                      <SmallStyle>
                        Cambridge University Press are committed to protecting
                        and <br /> respecting your privacy.{" "}
                        <a
                          href="/about-us/legal-notices/privacy-notice"
                          target="_blank"
                        >
                          Read more
                        </a>
                      </SmallStyle>
                      <a href="/" className="home-btn link-as-btn">
                        Back to homepage
                      </a>
                      <OrderDetails>
                        <ThankyouAccordionStyle>
                          <div className="tab">
                            <input
                              type="checkbox"
                              id="toggle-details"
                              tabIndex="-1"
                            />
                            <button onKeyPress={this.toggleOrderDetails}>
                              <label
                                className="tab-label"
                                htmlFor="toggle-details"
                              >
                                <span ref={this.toggleOrderDetailsRef}>
                                  View order details
                                </span>
                                <img src={`${caretDownIcon}`} alt="" />
                              </label>
                            </button>
                            <div className="tab-content">
                              {/* Available Order START */}
                              {this.state.processPurchaseOrderAvailable &&
                              this.state.processPurchaseOrderAvailable.length >
                                0 ? (
                                <div>
                                  <div className="container-fluid items-header">
                                    <div className="row">
                                      <div className="col-12">
                                        <p className="availability">
                                          Available
                                        </p>
                                      </div>
                                    </div>
                                    <div className="row items-header-label">
                                      <div className="col-8 col-sm-9 col-lg-10">
                                        <div className="row">
                                          {" "}
                                          <div className="col-2 img-col">
                                            Item
                                          </div>
                                          <div className="col-7 details"></div>
                                          <div className="col-2 price">
                                            Price
                                          </div>
                                          <div className="col-1 qty">Qty</div>
                                        </div>
                                      </div>
                                      <div className="col-4 col-sm-3 col-lg-2">
                                        <div className="row">
                                          <div className="col-12 total">
                                            Total
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.processPurchaseOrderAvailable.map(
                                    (item, index) => (
                                      <ConfirmationItem
                                        key={item.isbn}
                                        bookImage={item.imagePath}
                                        bookTitle={item.title}
                                        bookAuthor={item.author}
                                        bookPrice={item.price}
                                        bookDiscountedPrice={
                                          item.discountedPrice
                                        }
                                        bookISBN={item.isbn}
                                        bookType={item.type}
                                        bookSubTotal={
                                          item.totalAfterDiscount ||
                                          item.totalPrice
                                        }
                                        currency={this.state.currencyCodeSymbol}
                                        counter={item.quantity}
                                      />
                                    )
                                  )}
                                </div>
                              ) : (
                                ""
                              )}

                              {/* Available Order END */}
                              {/* Partial START */}
                              {this.state.processPurchaseOrderPartial &&
                              this.state.processPurchaseOrderPartial.length >
                                0 ? (
                                <div>
                                  <div className="container-fluid items-header">
                                    <div className="row">
                                      <div className="col-12">
                                        <p className="availability">
                                          Partially available
                                        </p>
                                      </div>
                                    </div>
                                    <div className="row items-header-label">
                                      <div className="col-8 col-sm-9 col-lg-10">
                                        <div className="row">
                                          {" "}
                                          <div className="col-2 img-col">
                                            Item
                                          </div>
                                          <div className="col-7 details"></div>
                                          <div className="col-2 price">
                                            Price
                                          </div>
                                          <div className="col-1 qty">Qty</div>
                                        </div>
                                      </div>
                                      <div className="col-4 col-sm-3 col-lg-2">
                                        <div className="row">
                                          <div className="col-12 total">
                                            Total
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.processPurchaseOrderPartial.map(
                                    (item, index) => (
                                      <ConfirmationItem
                                        key={item.isbn}
                                        bookImage={item.imagePath}
                                        bookTitle={item.title}
                                        bookAuthor={item.author}
                                        bookPrice={item.price}
                                        bookDiscountedPrice={
                                          item.discountedPrice
                                        }
                                        bookISBN={item.isbn}
                                        bookType={item.type}
                                        bookSubTotal={
                                          item.totalAfterDiscount ||
                                          item.totalPrice
                                        }
                                        currency={this.state.currencyCodeSymbol}
                                        counter={item.quantity}
                                        itemType="partial"
                                        readyQty={item.readyQty}
                                        duedQty={item.duedQty}
                                      />
                                    )
                                  )}
                                </div>
                              ) : (
                                ""
                              )}

                              {/* Partial END */}
                              {/* Preorder START */}
                              {this.state.processPurchaseOrderPreOrder &&
                              this.state.processPurchaseOrderPreOrder.length >
                                0 ? (
                                <div>
                                  {" "}
                                  <div className="container-fluid items-header">
                                    <div className="row">
                                      <div className="col-12">
                                        <p className="availability">Preorder</p>
                                      </div>
                                    </div>
                                    <div className="row items-header-label">
                                      <div className="col-8 col-sm-9 col-lg-10">
                                        <div className="row">
                                          {" "}
                                          <div className="col-2 img-col">
                                            Item
                                          </div>
                                          <div className="col-7 details"></div>
                                          <div className="col-2 price">
                                            Price
                                          </div>
                                          <div className="col-1 qty">Qty</div>
                                        </div>
                                      </div>
                                      <div className="col-4 col-sm-3 col-lg-2">
                                        <div className="row">
                                          <div className="col-12 total">
                                            Total
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.processPurchaseOrderPreOrder.map(
                                    (item, index) => (
                                      <ConfirmationItem
                                        key={item.isbn}
                                        bookImage={item.imagePath}
                                        bookTitle={item.title}
                                        bookAuthor={item.author}
                                        bookPrice={item.price}
                                        bookDiscountedPrice={
                                          item.discountedPrice
                                        }
                                        bookISBN={item.isbn}
                                        bookType={item.type}
                                        bookSubTotal={
                                          item.totalAfterDiscount ||
                                          item.totalPrice
                                        }
                                        currency={this.state.currencyCodeSymbol}
                                        counter={item.quantity}
                                      />
                                    )
                                  )}
                                </div>
                              ) : (
                                ""
                              )}

                              {/* Preorder END */}

                              <div className="row preorder-total-wrapper">
                                <div className="col-12 col-md-5">
                                  {this.state.processPurchaseOrderPreOrder &&
                                  this.state.processPurchaseOrderPreOrder
                                    .length > 0 &&
                                  parseFloat(
                                    this.state.processPurchaseOrderSummary
                                      .chargeNow
                                  ) > 0 ? (
                                    <div className="row total">
                                      <div className="col-6 label">
                                        Charge now
                                      </div>
                                      <div className="col-6 value">
                                        {this.state.currencyCodeSymbol}
                                        {
                                          this.state.processPurchaseOrderSummary
                                            .chargeNow
                                        }
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="col-12 col-md-2"></div>
                                <div className="col-12 col-md-5">
                                  <div className="row">
                                    <div className="col-5 label">Subtotal</div>
                                    <div className="col-7 value">
                                      {this.state.currencyCodeSymbol}
                                      {this.state.subTotal}
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-5 label">
                                      {this.state.deliveryLabel}
                                    </div>
                                    <div className="col-7 value">
                                      {this.state.currencyCodeSymbol}
                                      {this.state.shippingFee}
                                    </div>
                                  </div>
                                  {parseFloat(this.state.orderDiscountTotals) >
                                  0 ? (
                                    <div className="row promo">
                                      <div className="col-6 label">
                                        Promotional Code
                                      </div>
                                      <div className="col-6 value">
                                        {this.state.currencyCodeSymbol}
                                        {this.state.orderDiscountTotals}
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div className="row grand-total total">
                                    <div className="col-5 label">
                                      {this.state.totalLabel}
                                    </div>
                                    <div className="col-7 value">
                                      {this.state.currencyCodeSymbol}
                                      {this.state.total} <br />
                                      <span className="vat">
                                        Includes {this.state.taxLabel} of{" "}
                                        {this.state.currencyCodeSymbol}
                                        {this.state.taxFee}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <label
                              className="tab-label mobile-close"
                              htmlFor="toggle-details"
                            >
                              <span>Close</span>
                              <img src={`${caretDownIcon}`} alt="" />
                            </label>
                          </div>
                        </ThankyouAccordionStyle>
                      </OrderDetails>{" "}
                    </SectionStyle>
                  </div>
                  {this.state.isGuest ? (
                    <div className="col-12 col-lg-4">
                      <CreateAccountStyle>
                        <div className="create-content">
                          <p>
                            Create an account
                            <br />
                            in 30 seconds
                          </p>
                          <ul>
                            <li>Sign up for email alerts</li>
                            <li>Faster checkout next time</li>
                            <li>Access to resources</li>
                          </ul>
                          <a
                            href="/register"
                            className="link-as-btn"
                            onClick={this.createAccountClick}
                          >
                            Create an account
                          </a>
                        </div>
                      </CreateAccountStyle>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : this.state.unableToProcess ? (
                <UnableProcessStyle>
                  <img src={`${warningIcon}`} alt="" />
                  <h2>If you wish to complete your order, please contact <a href="/about-us/contact-us/">Customer Services</a>.</h2>
                  <p>
                    <strong>No payment has been taken.</strong>
                  </p>
                  {this.state.isUnableEmailAU ? (
                    <p>
                      Telephone number{" "}
                      <a href="tel:+61(03)86711400">+61 (03) 8671 1400</a> (9am
                      to 5pm AEST (Apr-Sep)/AEDT (Oct-Mar)), <br />
                      email{" "}
                      <a href={"mailto:" + this.state.unableToProcessEmail}>
                        {this.state.unableToProcessEmail}{" "}
                      </a>
                    </p>
                  ) : (
                    <p>
                      Email{" "}
                      <a href={"mailto:" + this.state.unableToProcessEmail}>
                        {this.state.unableToProcessEmail}
                      </a>
                    </p>
                  )}
                  {/* <p>
                If you wish to complete your order please contact{" "}
                <a href="/" target="_blank">
                  Customer Services
                </a>
                <br />
                quoting your reference number.
              </p> */}
                  <a
                    href={this.props.data.continueShoppingUrl}
                    className="link-as-btn"
                  >
                    Back to homepage
                  </a>
                </UnableProcessStyle>
              ) : this.state.displayError ? (
                <div className="api-error">
                  {/* <ApiError error={this.state.bagAPIErrors} /> */}
                  <CheckoutPageError
                    pageErrorCode={this.state.tyAPIErrorCode}
                    pageErrorMessage={this.state.tyAPIErrorMessage}
                    refreshPage={this.props.refreshPage}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </ThankyouBodyStyle>
      </div>
    );
  }
}

export default ThankYou;
